import {
  Button,
  Card,
  Col,
  Collapse,
  Form,
  InputNumber,
  Modal,
  Radio,
  Row,
  Tooltip,
} from "antd";
import TextArea from "antd/lib/input/TextArea";
import { useContext, useEffect, useState } from "react";
import { SignedInContext } from "../AppEnv";
import { SignedInDoctor } from "../auth/interfaces";
import { getDoctorData } from "../doctor/utils";
import { Patient, StrongHandType } from "../patients/interfaces";
import { editPatient } from "../patients/utils";
import { pexamTypeToFullname } from "./exams_definitions_utils";
import { PosturalExamination } from "./interfaces";
import { editPosturalExamination } from "./utils";
import { RocketOutlined } from "@ant-design/icons";
import { Configuration, OpenAIApi } from "openai";
import "./Exam.css";

const { Panel } = Collapse;

//OTHER TRY
/*
const fetchData = async (input: string) => {
  const response = await axios.post(
    "https://www.api.openai.com/v1/completions",
    {
      prompt: `Crea un report finale con un massimo di 250 parole con queste caratteristiche: "${input}"`,
      model: "text-davinci-003",
      max_tokens: 200,
      n: 1,
      stop: ".",
    },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${process.env.OPENAI_API_KEY}`,
      },
    }
  );

  return response.data.choices[0].text;
};
*/
//START API REQUEST OPENAI
/*
const configuration = new Configuration({
  apiKey: process.env.OPENAI_API_KEY,
});
const openai = new OpenAIApi(configuration);

const completion = openai.createCompletion({
  model: "text-davinci-003",
  prompt:
    "Crea un report finale con un massimo di 250 parole con queste caratteristiche linea bipupillare appare più alta, inclinazione del capo appare correttamente allineato" +
    {},
});
console.log(completion); */

//END OF APIREQUEST OPENAI

const API_KEY = "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"; // secure -> environment variable

const PosturalExamSummary2 = ({
  patient,
  posturalExamination,
  setPosturalExamination,
  setPatient,
}: {
  patient: Patient;

  posturalExamination: PosturalExamination;
  setPosturalExamination: Function;
  setPatient: Function;
}) => {
  console.log("summary 2");
  const signedInDoctor: SignedInDoctor =
    useContext(SignedInContext).signedInDoctor;
  const [doctorWhoPerformedTheExam, setDoctorWhoPerformedTheExam] =
    useState<string>(
      signedInDoctor.id == posturalExamination.doctorId
        ? signedInDoctor.name + " " + signedInDoctor.surname
        : ""
    );

  const [additionalNotes, setAdditionalNotes] = useState(
    posturalExamination.additionalNote || ""
  );

  const [isChange, setIsChange] = useState(true);

  function call() {
    console.log("AI Call OK");
    setIsChange(false);
    callOpenAIAPI();
  }

  async function callOpenAIAPI() {
    let text = "";
    if (!posturalExamination.testSelections) return;
    else
      for (let test of posturalExamination.testSelections)
        text += test.note ? test.note : "";
    const APIBody = {
      model: "gpt-3.5-turbo-instruct",
      prompt:
        "Sono un professionista e ho appena effettuato una Anamnesi al paziente " +
        patient.name +
        " " +
        patient.surname +
        " e ho appuntato le seguenti cose: " +
        text +
        ". Crea un riassunto discorsivo dell'anamnesi, se non ci sono dati devi dire: dati insufficienti.",
      temperature: 0,
      max_tokens: 600,
      top_p: 1.0,
      frequency_penalty: 0.0,
      presence_penalty: 0.0,
    };
    console.log(
      "Sono un professionista e ho appena effettuato una Anamnesi al paziente " +
        patient.name +
        " " +
        patient.surname +
        " e ho appuntato le seguenti cose: " +
        text +
        ". Crea un riassunto discorsivo dell'anamnesi, se non ci sono dati devi dire: dati insufficienti."
    );

    await fetch("https://api.openai.com/v1/completions", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + API_KEY,
      },
      body: JSON.stringify(APIBody),
    })
      .then((data) => {
        return data.json();
      })
      .then((data) => {
        //console.log(data);
        setAdditionalNotes(data.choices[0].text.trim()); // Positive or negative
      });
    setIsChange(true);
  }

  useEffect(() => {
    if (true || signedInDoctor.id != posturalExamination.doctorId) {
      getDoctorData(signedInDoctor, posturalExamination.doctorId)
        .then((res) =>
          setDoctorWhoPerformedTheExam(res.name + " " + res.surname)
        )
        .catch((err) => setDoctorWhoPerformedTheExam(""));
    }
  }, []);
  const [biometricBaseVisible, setBiometricBaseVisible] =
    useState<boolean>(false);

  const updateBaseBiometric = (key: string, value: number) => {
    let updPosturalExamination = { ...posturalExamination, [key]: value };
    setPosturalExamination(updPosturalExamination);
    editPosturalExamination(signedInDoctor, patient, updPosturalExamination);
    if (posturalExamination.date) {
      let peDate = new Date(posturalExamination.date);
      if (
        peDate.getDay() == new Date().getDay() &&
        peDate.getMonth() == new Date().getMonth() &&
        peDate.getFullYear() == new Date().getFullYear()
      ) {
        let updPatient = { ...patient, [key]: value };
        setPatient(updPatient); //if date corresponds upd info of patient
        editPatient(signedInDoctor, updPatient);
      }
    }
  };

  const updateAdditionalNotes = (notes: string) => {
    let updPosturalExamination = {
      ...posturalExamination,
      ["additionalNote"]: notes,
    };
    setPosturalExamination(updPosturalExamination);
    editPosturalExamination(signedInDoctor, patient, updPosturalExamination);
  };

  const numTestMade = posturalExamination.testSelections
    ? posturalExamination.testSelections.filter(
        (pe) => pe.selectedValue >= 0 && pe.passedValue != -2
      ).length
    : 0;
  const numTestPassed = posturalExamination.testSelections
    ? posturalExamination.testSelections.filter(
        (pe) => pe.selectedValue == pe.passedValue
      ).length
    : 0;
  const pendingTests = posturalExamination.testSelections
    ? posturalExamination.testSelections.filter((pe) => pe.passedValue != -2)
        .length - numTestMade
    : 0;
  return (
    <>
      <Col span={23}>
        <Card
          className="cardas"
          title={
            pexamTypeToFullname(posturalExamination.type) +
            " di " +
            patient.name +
            " " +
            patient.surname +
            (posturalExamination.date
              ? " in " +
                new Date(posturalExamination.date + "").toLocaleDateString()
              : "")
          }
          extra={
            doctorWhoPerformedTheExam.length > 0
              ? "Esame effettuato da " + doctorWhoPerformedTheExam
              : ""
          }
        >
          <Row>
            <h3>
              {numTestPassed > 0 ||
                numTestMade > 0 ||
                (pendingTests > 0 && (
                  <>
                    Risultato:
                    <span style={{ fontWeight: "bold" }}>
                      {numTestPassed + " su " + numTestMade}
                    </span>{" "}
                    test passati
                    {pendingTests > 0 && (
                      <>
                        {" "}
                        <span
                          style={{
                            background: "#ffd969",
                            paddingLeft: "2px",
                            paddingRight: "2px",
                            fontWeight: "bold",
                            borderRadius: "4px",
                          }}
                        >
                          {pendingTests} test mancanti
                        </span>{" "}
                      </>
                    )}
                  </>
                ))}
            </h3>
          </Row>

          <Collapse className="collap1">
            {posturalExamination.testSelections?.map((testSelection, index) => (
              <Panel
                className="panel1"
                header={testSelection.prefixNote}
                key={"ts_" + index}
                style={{
                  fontWeight: "bold",
                }}
              >
                <p
                  className="importas"
                  style={{
                    fontWeight: "normal",
                  }}
                >
                  {testSelection.note &&
                    ((testSelection.note.indexOf(": ") > 0 &&
                      testSelection.note.substring(
                        testSelection.note.indexOf(": ") + 2
                      )) ||
                      testSelection.note)}
                </p>
              </Panel>
            ))}
          </Collapse>
          <div style={{ textAlign: "right", marginTop: "16px" }}>
            <Button
              type="primary"
              onClick={() => setBiometricBaseVisible(true)}
            >
              Biometriche base
            </Button>
          </div>
        </Card>

        <Card className="cardas2">
          <Row className="cent">
            <Col span={18}>
              <h5>Note aggiuntive</h5>
              <TextArea
                showCount
                defaultValue={posturalExamination.additionalNote}
                maxLength={4096}
                style={{ height: 150 }}
                onChange={(e) => {
                  updateAdditionalNotes(e.target.value);
                  setAdditionalNotes(e.target.value);
                }}
                value={additionalNotes}
                count={undefined}
              />
            </Col>
            <Col span={2} className="cent1">
              <div className="cent">
                <Tooltip title="Genera Testo Con AI" className="too1">
                  <button
                    className={isChange ? "btnai" : "btnai-ok"}
                    onClick={() => call()}
                  >
                    <div className="loader"></div>
                    <RocketOutlined
                      className={isChange ? "rock" : "rock-ok"}
                      rev={undefined}
                    />

                    <div id="container-stars">
                      <div id="stars"></div>
                    </div>
                    <div id="glow">
                      <div className="circle"></div>
                      <div className="circle"></div>
                    </div>
                  </button>
                </Tooltip>
              </div>
            </Col>
          </Row>
        </Card>
        <Modal
          title="Dati biometrici base"
          centered
          open={biometricBaseVisible}
          footer={false}
          onOk={() => setBiometricBaseVisible(false)}
          onCancel={() => setBiometricBaseVisible(false)}
          width={600}
        >
          <Form
            initialValues={{
              height: posturalExamination.height,
              weight: posturalExamination.weight,
              footSize: posturalExamination.footSize,
              strongHand: posturalExamination.strongHand,
            }}
          >
            <Row>
              <Col span={8}>
                <Form.Item name="height" label="Altezza (cm)">
                  <InputNumber
                    min={0}
                    max={250}
                    step={0.5}
                    onChange={(value: number | null) => {
                      if (value !== null) {
                        updateBaseBiometric("height", value);
                      }
                    }}
                  />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item name="weight" label="Peso (kg)">
                  <InputNumber
                    min={0}
                    max={450}
                    step={0.5}
                    onChange={(value: number | null) => {
                      if (value !== null) {
                        updateBaseBiometric("height", value);
                      }
                    }}
                  />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item name="footSize" label="Piede (EU)">
                  <InputNumber
                    min={32}
                    max={50}
                    step={0.5}
                    onChange={(value: number | null) => {
                      if (value !== null) {
                        updateBaseBiometric("height", value);
                      }
                    }}
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item name="strongHand" label="Mano Forte">
                  <Radio.Group
                    onChange={(e) =>
                      updateBaseBiometric("strongHand", e.target.value)
                    }
                  >
                    <Radio.Button value={StrongHandType.SX}>Sx</Radio.Button>
                    <Radio.Button value={StrongHandType.SX_DX}>
                      Ambidestro
                    </Radio.Button>
                    <Radio.Button checked value={StrongHandType.DX}>
                      Destro
                    </Radio.Button>
                  </Radio.Group>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Modal>
      </Col>
    </>
  );
};

export default PosturalExamSummary2;
function setIsLoading(arg0: boolean) {
  throw new Error("Function not implemented.");
}
